<template>
    <div data-test="resources-filter" class="col-span-12">
        <analytics-sidebar-box
            @reset="emit('reset')"
            :canReset="selectedResources.length > 0"
            :hasContent="selectedResources.length > 0"
        >
            <template v-slot:title> Resources </template>

            <div
                v-if="selectedResources.length"
                @click="emit('click')"
                class="group/selection cursor-pointer select-none relative text-xs flex flex-col gap-2"
            >
                <div
                    v-for="resource in selectedResources"
                    :key="`select_${resource.resource_type}_${resource.resource_id}`"
                    class="flex items-baseline justify-start gap-2 pr-1 transition duration-300 group-hover/selection:opacity-5 group-hover/selection:blur-[1px]"
                >
                    <div class="min-w-0 grow break-words">
                        {{
                            ('resource_name' in resource ? resource.resource_name : '') ||
                            resourceName(resource) ||
                            'Loading...'
                        }}
                    </div>
                    <font-awesome-icon
                        widthAuto
                        :icon="resourceTypeIcon(resource.resource_type, 'regular')"
                        class="translate-y-0.5 text-sm"
                    ></font-awesome-icon>
                </div>

                <div
                    class="absolute inset-0 flex flex-wrap items-center justify-center gap-2 overflow-hidden text-xs font-bold opacity-0 transition group-hover/selection:opacity-100 group-hover/selection:delay-75"
                >
                    <div
                        class="absolute flex items-center justify-center gap-2 transition duration-300"
                        :class="[selectingResources ? 'opacity-100' : 'translate-y-12 opacity-0']"
                    >
                        Done
                        <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                    </div>
                    <div
                        class="absolute flex items-center justify-center gap-2 transition duration-300"
                        :class="[!selectingResources ? 'opacity-100' : '-translate-y-12 opacity-0']"
                    >
                        Manage Selection
                        <font-awesome-icon widthAuto :icon="faPencil"></font-awesome-icon>
                    </div>
                </div>
            </div>

            <template v-slot:actions>
                <button
                    type="button"
                    @click="emit('click')"
                    :disabled="selectingSnippets"
                    data-test="handle-resource-selection"
                    class="group/add-resources -mt-3 -mx-3 -mb-3 flex w-[calc(100%+24px)] py-3 rounded-b-lg justify-center relative overflow-hidden items-center text-xs text-black bg-slate-200 border border-solid border-b-0 border-x-0 border-t-slate-300 font-semibold transition hover:bg-slate-300"
                    :class="{
                        'cursor-pointer': !selectingSnippets,
                        'opacity-50 cursor-not-allowed pointer-events-none': selectingSnippets,
                    }"
                >
                    <div
                        class="flex items-center gap-2 transition duration-300"
                        :class="{ 'group-hover/add-resources:-translate-y-12': selectingResources }"
                    >
                        Add Resources
                        <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                    </div>
                    <div
                        class="absolute inset-0 flex items-center justify-center gap-2 transition duration-300 translate-y-12"
                        :class="{ 'group-hover/add-resources:translate-y-0': selectingResources }"
                    >
                        Done
                        <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                    </div>
                </button>
            </template>
        </analytics-sidebar-box>
    </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleCheck, faCirclePlus, faPencil } from '@fortawesome/pro-solid-svg-icons';
import AnalyticsSidebarBox from '~/components/analytics/partial/sidebar/AnalyticsSidebarBox.vue';
import { useAnalyticsSelectResources } from './useAnalyticsSelectResources';
import { useAnalyticsSelectSnippets } from '~/components/analytics/partial/select-snippets/useAnalyticsSelectSnippets';
import { resourceTypeIcon } from '~/utils/analytics';

const { selectingResources, selectedResources, resourceName } = useAnalyticsSelectResources();
const { selectingSnippets } = useAnalyticsSelectSnippets();

const emit = defineEmits<{
    click: [];
    reset: [];
}>();
</script>
